import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { KeycloackService } from "./keycloack.service";
import { authConfig } from './auth-config';
import { UtentiService } from "../services/utenti.service";
import { ServiceRespone } from "../model/serviceResponse";
import { IAuthService } from "./io.authService";
import { Applicazione, UtenteNuovo } from "../model/utente/utenteNuovo";
import { Permesso, Processo } from "../model/utente/permesso";
import { Utente } from "../model/utente/utente";

@Injectable({ providedIn: 'root' })
export class AuthService implements IAuthService {

  private myKeycloak = this._KeyCloakService.istance;
  private _utenteLoggato: Utente;

  private isAuthenticatedSubject$ = new BehaviorSubject<boolean>(false);
  public isAuthenticated$ = this.isAuthenticatedSubject$.asObservable();

  private isUserErrorSubject$ = new BehaviorSubject<String>(null);
  public isUserError$ = this.isUserErrorSubject$.asObservable();

  constructor(
    private usrServ: UtentiService,
    private _KeyCloakService: KeycloackService
  ) {
    this.myKeycloak.onTokenExpired = () => {
      this.updateToken();
    };

  }


  public login() {
    console.log("LOGIN");
    this._utenteLoggato = null;
    this.myKeycloak
      .init({ onLoad: 'login-required', checkLoginIframe: false, promiseType: 'native' })
      .success(async (authenticated: boolean) => {
        console.log("Login success :" + authenticated);
        console.log(this.myKeycloak);
        this.usrServ.getUtenteLoggato().subscribe(
          response => {
            let resp: ServiceRespone = response;
            console.log(resp);
            if (resp.errorMex == null) {
              let nuovoUtente: UtenteNuovo = resp.respObj;
              let permessi : Permesso[] = nuovoUtente.permessi.EDITH;
              if (permessi == null || permessi == undefined || permessi.length != 1) {
                console.log("Error: l'utente non ha i permessi corretti per Edith");
                this.isUserErrorSubject$.next("l'utente non ha i permessi corretti per Edith"); //da tradurre
              } else {
                let utenteEdith: Utente = new Utente();
                utenteEdith.id = nuovoUtente.id;
                utenteEdith.RIDP = nuovoUtente.ridp;
                utenteEdith.nome = nuovoUtente.nome;
                utenteEdith.cognome = nuovoUtente.cognome;
                utenteEdith.idFornitore = nuovoUtente.idFornitore;
                utenteEdith.tipologiaUtente = permessi[0].profilo;
                console.log("utente Edith", utenteEdith);
                this._utenteLoggato = utenteEdith;
                this._authSuccess();
              }
              
            } else {
              console.log(resp.errorMex);
              this.isUserErrorSubject$.next(resp.errorMex);
            }
          },
          err => {
            console.log(err)
            this.isUserErrorSubject$.next(err);
          })
      })
      .error(() => {
        console.log('Failed to login, redirecting to login page');
        this.login();
      });
  }

  private _authSuccess(): void {
    this.isAuthenticatedSubject$.next(true);
  }

  public logout() {
    this.myKeycloak.clearToken();
    this.myKeycloak.logout({ redirectUri: authConfig['redirectUri'] });
  }

  public updateToken() {
    console.log("UPDATE TOKEN")
    this.myKeycloak
      .updateToken(parseInt(
        authConfig['timeUpdateTokenBeforeExpires']
      ))
      .success(() => {
        this._authSuccess();
      })
      .error(() => {
        this.logout();
      });
  }

  public get accessToken() {
    return this.myKeycloak.token;
  }

  public getUtenteLoggato() {
    return this._utenteLoggato;
  }

}